export const isObjectLiteral = (obj: any): boolean => {
  let o = obj;
  return typeof obj !== "object" || obj === null
    ? false
    : (function () {
        while (Object.getPrototypeOf((o = Object.getPrototypeOf(o))) !== null);
        return Object.getPrototypeOf(obj) === o;
      })();
};
